import "./LoadingScreen.css";
// import Logo from "../../public/assets/logos/logos2.png"; // <-- change to your logo path

export default function LoadingScreen() {
  return (
    <div className="loading-wrapper">
      <img src="/assets/logos/logos2.png" alt="Logo" className="loading-logo" />
      {/* <div className="loader"></div> */}
    </div>
  );
}
